import { api } from './api';

const AccountService = {
  getProfile: () => {
    return api.authGet('/auth/owner/profile');
  },
  updateProfile: (params: any) => {
    return api.authPutForm('/auth/owner/profile', params);
  },
  changePassword: (params: any) => {
    return api.authPut('/auth/owner/change-password', params);
  },
  confirmSubcription: (params: any) => {
    return api.authPut('/auth/owner/subscription', params);
  },
  setupStripe: (code: string) => {
    return api.authPostForm('/auth/owner/app/setup-stripe', { code });
  },
  cancelSubscription: () => {
    return api.authPut('/auth/owner/cancel-subscription');
  },
  subscriptionStripe: () => {
    return api.authPut('/auth/owner/create-checkout-session');
  },
  refreshToken: () => {
    return api.refreshToken('/refresh-token-owner')
  },
  sendSupport: (params: any) => {
    return api.authPostForm('/support', params)
  },
  deploy: (domain: string) => {
    return api.authPost(`/auth/owner/app/deploy`, { domain });
  }
};

export default AccountService;
